import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { staticDevicesApi } from '@/api/index';
import type { IRequestBodyFilter } from '@/api/routes/static-devices/types';

export const fetchStaticDevicesFilters = createAsyncThunk(
  'staticDevicesFilters',
  async (params: IRequestBodyFilter, thunkAPI) => {
    try {
      const response = await staticDevicesApi.getFilters(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
